import { useCallback, useState } from "react";

export const useImages = (length = 0) => {
  const [currentImage, setImage] = useState(0);

  const handleSetCurrentImage = (id) => setImage(id);

  const handleNextImage = useCallback(() => {
    setImage(currentImage + 1 === length ? 0 : currentImage + 1);
  }, [currentImage, length]);

  const handlePrevImage = useCallback(() => {
    setImage(currentImage === 0 ? length - 1 : currentImage - 1);
  }, [currentImage, length]);

  return {
    handleSetCurrentImage,
    handleNextImage,
    handlePrevImage,
    currentImage,
  };
};
